import React, {Component} from 'react';
import common from './../../../common';

class Newsletter extends Component {
    onClickNotNow = (gamedayId, guid) => {
        let objCookie = common.getLocalStorage('objGamedayNewsletter');
        if (!objCookie) {
            objCookie = {};
        }
        objCookie[guid] = gamedayId;
        common.setLocalStorage('objGamedayNewsletter', objCookie);
        common.customTracking('Not Now - Newsletter');
        this.forceUpdate();
    };

    fnPostSubscribeAPI(isSubscribe) {
        common.customTracking('Subscribe to Newsletter');
        this.props.fnPostSubscribeAPI(isSubscribe);
    }

    render() {
        let gamedayId = this.props.gamedayId;
        let guid = common.getGUID();
        let objGamedayNewsletter = common.getLocalStorage('objGamedayNewsletter');
        let GamedayNewsletter = (objGamedayNewsletter && objGamedayNewsletter[guid] ? objGamedayNewsletter[guid] : 0);
        let IsNewsletter = this.props.IsNewsletter;
        let trans = this.props.trans;
        if (GamedayNewsletter && Number(GamedayNewsletter) === Number(gamedayId) || Number(IsNewsletter)) {
            return null;
        }
        return (<div className="si-card si-newsletter-card">
            <div className="si-main-text-block">
                <div className="text-block">
                    <div className="si-mt-block">
                        <div className="si-newsletter-block">
                            <div className="si-mt-text-title si-newsletter-txt"><span>{trans.nlcHeading}</span></div>
                            <div className="si-text-descp">{trans.nlcMessage}</div>
                        </div>
                        <div className="si-mail-block">
                            <div className="si-mail-icon"><i className="icon-ucl-newsletter"/></div>
                        </div>
                    </div>
                </div>
                <div className="button-block">
                    <div className="si-btn btn-sm" onClick={() => {
                        this.fnPostSubscribeAPI(1)
                    }}>{trans.nlcSubscribe}</div>
                    <div className="si-btn btn-sm si-notnow" onClick={() => {
                        this.onClickNotNow(gamedayId, guid)
                    }}>{trans.nlcNotNow}</div>
                </div>
            </div>
        </div>);
    }
}

export default Newsletter;


// WEBPACK FOOTER //
// ./src/components/home/cards/Newsletter.js